import { Pipe, PipeTransform } from "@angular/core";
import { Ticket } from "../_interfaces/ticket";
import { ITicketState } from "../_interfaces/TicketState";
import { TicketEditService } from "../_provider/ticket-edit.service";


    @Pipe({
        name: "TicketStateDescription"
    })
    export class TicketStateDescription implements PipeTransform{

        constructor(private ticketEditSrv: TicketEditService){}
        /**
         * Gibt String anhand der Status-Id zurück
         * @param {number} state Id des Stutuses
         * @param {boolean[]} args stelle 0 ist ab ticket unabhängig von status abgeschlossen ist
         * @returns {string}
         */
        transform(state: number, ...args: boolean[]) {
            const ticketState: ITicketState = this.ticketEditSrv.ticketStates.find(tS=>tS.id == state)
            if(ticketState) return ticketState.description
            if (args[0]) return "Abgeschlossen"
            return "<Status gelöscht>"
        }
    }

    @Pipe({
        name: "TicketStateColor"
    })
    export class TicketStateColor implements PipeTransform{

        constructor(private ticketEditSrv: TicketEditService){}

        /**
         * Gibt zurück ob übergebener Status abgeschlossen ist
         * @param {number} value id des Statuses
         * @param {boolean} args args stelle 0 ist ab ticket unabhängig von status abgeschlossen ist
         * @param {number} args args stelle 1 opacity
         * @returns {string}
         */
        transform(state: number, ...args: any[]): string {
            return TicketStateColor.getColor(state, this.ticketEditSrv.ticketStates, ...args)
        }

        public static getColor(state: number, states: ITicketState[], ...args: any[]): string{
            const ticketState: ITicketState = states.find(tS=>tS.id == state)
            if(ticketState?.closed || args[0]) return `rgb(var(--greenRGB), ${args[1] || args[2] || 1})`
            if(!ticketState) return `rgb(var(--redRGB), ${args[1] || args[2] || 1})`
            if(ticketState.wait) return `rgb(var(--yellowRGB), ${args[1] || args[2]|| 1})`
            return `rgb(var(--redRGB), ${args[1] || args[2] || 1})`
        }
    }   

    @Pipe({
        name: "TicketStateIcon"
    })
    export class TicketStateIcon implements PipeTransform{
        constructor(private ticketEditSrv: TicketEditService){}
        transform(state: number, ...args: any[]) {
            const ticketState: ITicketState = this.ticketEditSrv.ticketStates.find(tS=>tS.id == state)
            if(ticketState?.closed) return "fa-check"
            if(!ticketState) return "fa-hammer"
            if(ticketState.wait) return "fa-hand"
            return "fa-hammer"
        }
    }

    // @Pipe({
    //     name: "TicketStateMainDescription"
    // })
    // export